export const META_KEYWORDS = 'home.main.meta.keywords';
export const TITLE = 'home.head.title';
export const DESCRIPTION = 'home.head.title';
